<template>
  <div class="bg-white shadow rounded sm:rounded-lg p-4 sm:p-6">
    <div>
      <div class="bg-yellow-50 px-5 py-4 rounded">
        <dl class="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <!-- Account Number -->
          <div class="sm:col-span-1">
            <dt class="text-sm text-gray-600">Account Number:</dt>
            <dd class="mt-1 text-sm font-medium text-gray-900">
              {{ userProperty.account_no }}
            </dd>
          </div>

          <!-- Property Address -->
          <div class="sm:col-span-1">
            <dt class="text-sm text-gray-600">Property Address:</dt>
            <dd class="mt-1 text-sm font-medium text-gray-900">
              {{ userProperty.Situs_Address }}
            </dd>
          </div>

          <!-- Owner Name -->
          <div class="sm:col-span-1">
            <dt class="text-sm text-gray-600">Owner name:</dt>
            <dd class="mt-1 text-sm font-medium text-gray-900">
              {{ userProperty.Owner_Name }}
            </dd>
          </div>

          <div class="sm:col-span-1">
            <dt class="text-sm text-gray-600">Mailing Adress:</dt>
            <dd class="mt-1 text-sm font-medium text-gray-900">
              {{ userProperty.Owner_Address }}
            </dd>
          </div>



        </dl>
      </div>

      <!-- What is your reason for discontinuing this service? -->
      <div class="mt-4 sm:mt-5 md:grid md:grid-cols-2 md:gap-6">
        <div class="md:col-span-2">

          <div class="block text-sm text-gray-600 mb-2">
            What is your reason for discontinuing this service?
          </div>

          <div class="space-y-4">
            <select v-model="data.reason_to_discontinue" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full text-sm border-gray-300 rounded-md" :class="{'border-red-500' : errors.reason_to_discontinue_error}">
              <option value="" selected>Please select</option>
              <option value="The reduction you got me last year wasn't big enough"> The reduction you got me last year wasn't big enough </option>
              <option value="I don't own the property anymore"> I don't own the property anymore </option>
              <option value="I am planning on moving"> I am planning on moving </option>
              <option value="I am concerned that protesting might negatively affect me somehow"> I am concerned that protesting might negatively affect me somehow </option>
              <option value="I think you made an error last year"> I think you made an error last year </option>
              <option value="I’m hiring another tax agent"> I’m hiring another tax agent </option>
              <option value="I'm protesting on my own this year"> I'm protesting on my own this year </option>
            </select>
          </div>

          <div class="mt-3" v-if="data.reason_to_discontinue == 'Other'">
            <input type="text" v-model="data.reason_to_discontinue_other" placeholder="Please enter other reason" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full text-sm border-gray-300 rounded-md" :class="{'border-red-500' : errors.reason_to_discontinue_other_error}" />
          </div>

          <div class="text-red-600 text-sm px-1 py-1" v-if="errors.reason_to_discontinue_error || errors.reason_to_discontinue_other_error">
            <i class="fa fa-exclamation-triangle"></i> {{ errors.reason_to_discontinue_message }}
          </div>
        </div>
      </div>

      <!-- Can we still be friends? -->
      <div class="mt-4 sm:mt-5 md:grid md:grid-cols-2 md:gap-6">
        <div class="md:col-span-2">

          <div class="block text-sm text-gray-600 mb-2">
            Can we still be friends?
          </div>

          <div class="space-y-4">
            <select v-model="data.can_still_be_friends" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full text-sm border-gray-300 rounded-md" :class="{'border-red-500' : errors.can_still_be_friends_error}">
              <option value="" selected disabled>Please select</option>
              <option value="No, please don't call or email me for any reason."> No, please don't call or email me for any reason. </option>
              <option value="Yes, if you need to communicate something to me, it is still ok to contact me."> Yes, if you need to communicate something to me, it is still ok to contact me. </option>
            </select>
          </div>

          <div class="text-red-600 text-sm px-1 py-1" v-if="errors.can_still_be_friends_error">
            <i class="fa fa-exclamation-triangle"></i> {{ errors.can_still_be_friends_message }}
          </div>
        </div>
      </div>

      <!--Only withdraw this year’s protest, but leave our representation in place so we can protest for you next year-->
      <div class="mt-4 sm:mt-5 md:grid md:grid-cols-2 md:gap-6" v-if="false">
        <div class="md:col-span-2">

          <div class="block text-sm text-gray-600 mb-2">
            Only withdraw this year’s protest, but leave our representation in place so we can protest for you next year
          </div>

          <div class="space-y-4">
            <select v-model="data.keep_our_representation" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full text-sm border-gray-300 rounded-md" :class="{'border-red-500' : errors.can_still_be_friends_error}">
              <option value="" selected disabled>Please select</option>
              <option value="Withdraw this year">Withdraw this year</option>
              <option value="Remove our representation permanently">Remove our representation permanently</option>
            </select>
          </div>

          <div class="text-red-600 text-sm px-1 py-1" v-if="errors.keep_our_representation_error">
            <i class="fa fa-exclamation-triangle"></i> {{ errors.keep_our_representation_message }}
          </div>
        </div>
      </div>

      <!-- Additional questions or comments -->
      <div class="mt-4 sm:mt-5 md:grid md:grid-cols-2 md:gap-6">
        <div class="md:col-span-2">
          <div class="block text-sm text-gray-600 mb-2">
            Additional questions or comments
          </div>

          <div class="space-y-4">
            <textarea v-model="data.additional_questions_or_comments_to_revoke" rows=4 placeholder="Please enter other reason" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full text-sm border-gray-300 rounded-md">
            </textarea>
          </div>
        </div>
      </div>

      <div class="mt-4 sm:mt-6 sm:flex sm:items-center sm:justify-center sm:flex-row-reverse">
        <button type="button" @click="submitHandler()" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-6 py-2 bg-indigo-600 font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-4 sm:w-auto text-sm">
            Sign Revocation
        </button>

        <a :href="siteUrl() + '/user-properties'" class="mt-4 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-6 py-2 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto text-sm">
          Back
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { helpers } from "../../mixins/helpers.js";
export default {
  props: ["userProperty"],
  mixins: [helpers],
  data() {
    return {
      data: {},
      errors: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.data = {
        ...this.data,
        ...{
          reason_to_discontinue: "",
          can_still_be_friends: "",
          additional_questions_or_comments_to_revoke: "",
          keep_our_representation: ""
        },
      };
    },

    submitHandler() {
      if (this.validateData()) return;

      localStorage.setItem('cancelFormInput',JSON.stringify(this.data))

      window.location.href =
            "/user-properties/" + this.userProperty.uid + "/sign-revoke-aoa-agreement";
    },
    validateData() {
      this.errors = {};
      let error = false;

      if (!this.data.reason_to_discontinue) {
        this.errors.reason_to_discontinue_error = true;
        this.errors.reason_to_discontinue_message = "Please select an option";
        error = true;
      }

      if (
        this.data.reason_to_discontinue == "Other" &&
        !this.data.reason_to_discontinue_other
      ) {
        this.errors.reason_to_discontinue_other_error = true;
        this.errors.reason_to_discontinue_message =
          "Please specify other reason to discontinue";
        error = true;
      }

      if (!this.data.can_still_be_friends) {
        this.errors.can_still_be_friends_error = true;
        this.errors.can_still_be_friends_message = "Please select an option";
        error = true;
      }

      // if (this.data.can_still_be_friends == 'Yes, if you need to communicate something to me, it is still ok to contact me.' && !this.data.keep_our_representation) {
      //   this.errors.keep_our_representation_error = true;
      //   this.errors.keep_our_representation_message = "Please select an option";
      //   error = true;
      // }

      return error;
    },
  },
};
</script>
